document.addEventListener("scroll", function() {
  // スクロールがページトップにあるかを確認
  if (window.scrollY === 0) {
    // header-wrapperにscroll-topクラスを付与
    document.querySelector(".header-wrapper").classList.add("scroll-top");
  } else {
    // スクロール位置がトップでない場合、scroll-topクラスを削除
    document.querySelector(".header-wrapper").classList.remove("scroll-top");
  }
});